import ticketShowComponent from './ticket-show.component';

const ticketShowModule = angular.module('ticketShow', [
])
  .component('ticketShow', ticketShowComponent)
  .name;

export default ticketShowModule;
